import { Link } from 'react-router-dom';
import { Bitcoin, Sparkles, ArrowRight } from 'lucide-react';
import { OpportunityCards } from './OpportunityCards';

export const InvestmentOpportunitiesHero = ({ compact = false, onCta, onSelectOpportunity }) => {
    const Cta = onCta ? 'button' : Link;
    const ctaProps = onCta ? { type: 'button', onClick: onCta } : { to: '/inversion#apartar' };
    return (
        <section className={`metal-frame rounded-3xl overflow-hidden ${compact ? 'p-5 sm:p-6' : 'p-6 sm:p-10'}`} data-testid="investment-opportunities-hero">
            <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, #f9e27a 0, transparent 40%), radial-gradient(circle at 85% 80%, #e8e8ec 0, transparent 35%)' }} />
            <img src="/lions-advisory-logo.jpg" alt="" aria-hidden="true" draggable="false"
                className={`pointer-events-none absolute -right-10 -bottom-10 object-cover rounded-full opacity-[0.12] ${compact ? 'w-56 h-56' : 'w-80 h-80 sm:w-[26rem] sm:h-[26rem]'}`} />

            <div className={`relative flex flex-col ${compact ? 'sm:flex-row sm:items-center' : 'lg:flex-row lg:items-center'} gap-6`}>
                <div className={`flex-shrink-0 rounded-2xl overflow-hidden ring-1 ring-[#d4af37]/60 shadow-[0_0_40px_rgba(212,175,55,0.25)] ${compact ? 'w-16 h-16' : 'w-24 h-24 sm:w-32 sm:h-32'}`}>
                    <img src="/lions-advisory-logo.jpg" alt="Lions Advisory Group" className="w-full h-full object-cover" draggable="false" />
                </div>

                <div className="flex-1 min-w-0">
                    <p className="chrome-text text-[10px] sm:text-[11px] font-bold tracking-[0.38em] uppercase mb-2" data-testid="investment-hero-brand">Lions Advisory Group</p>
                    <h2 className={`chrome-text font-extrabold uppercase leading-[0.95] tracking-tight ${compact ? 'text-2xl sm:text-3xl' : 'text-4xl sm:text-5xl lg:text-6xl'}`}
                        style={{ fontFamily: 'Poppins, Inter, sans-serif' }} data-testid="investment-hero-title">
                        Investment<br />Opportunities
                    </h2>
                    <div className="metal-line my-4 max-w-md" />
                    <p className={`text-slate-300 font-light max-w-xl ${compact ? 'text-sm' : 'text-base md:text-lg'}`} data-testid="investment-hero-tagline">
                        «Descubre próximas oportunidades de inversión y registra anticipadamente tu interés en participar».
                    </p>
                    {!compact && (
                        <div className="flex flex-wrap gap-2 mt-4">
                            {['BTC', 'USDT TRC20', 'Registro anticipado'].map((t) => (
                                <span key={t} className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold text-[#f3e3a6] border border-[#d4af37]/40 bg-[#d4af37]/10">
                                    {t === 'Registro anticipado' ? <Sparkles className="w-3 h-3" /> : <Bitcoin className="w-3 h-3" />}{t}
                                </span>
                            ))}
                        </div>
                    )}
                </div>

                <div className="flex-shrink-0">
                    <Cta {...ctaProps} className={`metal-btn ${compact ? 'px-6 py-3 text-xs' : 'px-9 py-4 text-sm'}`} data-testid="investment-hero-cta">
                        Apartar inversión <ArrowRight className="w-4 h-4" />
                    </Cta>
                </div>
            </div>
            <OpportunityCards compact={compact} limit={compact ? 3 : undefined} onSelect={onSelectOpportunity} />
        </section>
    );
};
